import { createSelector } from 'reselect';
import { StoreState } from '../../store-interfaces';

const getSuppressionLists = (state: StoreState) =>
  state.suppressionLists.entities;

export const selectWebhookSuppressionList = createSelector(
  [getSuppressionLists],
  suppressionLists =>
    suppressionLists.filter(c => c.sourceKind === 'suppression_webhook'),
);

export const selectGoHighLevelSuppressionList = createSelector(
  [getSuppressionLists],
  suppressionLists =>
    suppressionLists.filter(c => c.sourceKind === 'gohighlevel'),
);

export const selectKlaviyoSuppressionList = createSelector(
  [getSuppressionLists],
  suppressionLists =>
    suppressionLists.filter(
      list =>
        list.sourceKind === 'klaviyo_api_key' ||
        list.sourceKind === 'klaviyo_oauth',
    ),
);

export const selectShopifySuppressionList = createSelector(
  [getSuppressionLists],
  suppressionLists =>
    suppressionLists.filter(
      list =>
        list.sourceKind === 'shopify_api_key' ||
        list.sourceKind === 'shopify_oauth',
    ),
);

export const selectZapierSuppressionList = createSelector(
  [getSuppressionLists],
  suppressionLists =>
    suppressionLists.filter(list => list.sourceKind === 'zapier'),
);

export const selectHubspotSuppressionList = createSelector(
  [getSuppressionLists],
  suppressionLists =>
    suppressionLists.filter(
      list =>
        list.sourceKind === 'hubspot_api_key' ||
        list.sourceKind === 'hubspot_oauth',
    ),
);

export const selectSendlaneSuppressionList = createSelector(
  [getSuppressionLists],
  suppressionLists => suppressionLists.filter(c => c.sourceKind === 'sendlane'),
);

export const selectOmnisendSuppressionList = createSelector(
  [getSuppressionLists],
  suppressionLists => suppressionLists.filter(c => c.sourceKind === 'omnisend'),
);
